// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2XfnO","resendInfoText":"OnGoingPaymentBox_resendInfoText__2Rlny"};